var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentSubmission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9243",
    "data-name": "Group 9243",
    transform: "translate(-14259 -9096)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1803",
    "data-name": "Ellipse 1803",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(14259 9096)",
    fill: "#d34a7c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "document-text",
    transform: "translate(14269.375 9105.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10438",
    "data-name": "Path 10438",
    d: "M30.094,15.75H20.25a3.375,3.375,0,0,1-3.375-3.375V2.531a.281.281,0,0,0-.281-.281H10.125a4.5,4.5,0,0,0-4.5,4.5v22.5a4.5,4.5,0,0,0,4.5,4.5h15.75a4.5,4.5,0,0,0,4.5-4.5V16.031a.281.281,0,0,0-.281-.281ZM23.625,27H12.375a1.125,1.125,0,0,1,0-2.25h11.25a1.125,1.125,0,0,1,0,2.25Zm0-5.625H12.375a1.125,1.125,0,0,1,0-2.25h11.25a1.125,1.125,0,0,1,0,2.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10439",
    "data-name": "Path 10439",
    d: "M29.476,13.26,19.365,3.149a.141.141,0,0,0-.24.1v9.127A1.125,1.125,0,0,0,20.25,13.5h9.127a.141.141,0,0,0,.1-.24Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSubmission);
export default __webpack_public_path__ + "static/media/document-submission.c9967f495ff2e318e75e034278eb5f65.svg";
export { ForwardRef as ReactComponent };